export default __webpack_public_path__ + "static/media/beej-white.c4711595.png";